export default "__VITE_ASSET__30e50851__"